import { useState } from "react";
import { TextField } from "@mui/material";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button, useNotify, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import { dormitoryRequests } from "api/dormitoryApi";

const todayISO = () => new Date().toISOString().slice(0, 10);

const CheckOutDialog = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [movedOutAt, setMovedOutAt] = useState(todayISO());

  const handleConfirm = async () => {
    await dataProvider.customRequest(
      dormitoryRequests.checkOutAccommodation(record.id),
      { movedOutAt },
      "PUT",
    );
    notify("Успешно напускане на студент", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleConfirm}
      titleContent="Напускане на студент"
      saveTitle="Потвърди напускане"
      closeTitle="Отказ"
      confirmEnabled={!!movedOutAt}
      resetProps={() => setMovedOutAt(todayISO())}
      dialogProps={{
        sx: {
          "& .MuiDialogTitle-root": { display: "none" },
          "& .MuiDialogContent-root": { fontFamily: "inherit", paddingTop: 3 },
          "& .MuiInputBase-root, & .MuiInputLabel-root, & .MuiFormHelperText-root, & .MuiDialogActions-root": {
            fontFamily: "inherit",
          },
        },
      }}
      triggerButton={
        <Button
          startIcon={<LogoutIcon />}
          label="Напусни"
        />
      }
    >
      <TextField
        type="date"
        variant="filled"
        size="small"
        label="Дата на напускане"
        value={movedOutAt}
        onChange={e => setMovedOutAt(e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{
          min: record?.movedInAt?.slice(0, 10),
          max: new Date().toISOString().slice(0, 10),
        }}
        fullWidth
        required
        helperText="По подразбиране е избрана днешна дата."
      />
    </ConfirmModal>
  );
};

export default CheckOutDialog;
